export default __webpack_public_path__ + "static/media/cer7.09ac55e1.png";